<template>
   <div class="crud-wrapper">
      <crud :grid-columns="gridColumns" :gridSettings="{noNew: true}"
            :pageFilters="pageFilters" obj="affiliate">
      </crud>
   </div>
</template>

<script>
    import numeral from 'numeral';
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';

    export default PageClass.extend({
        name: 'affiliates',

        data () {
            return {

                gridColumns: [
                    {
                        dataField: 'name',
                        caption: 'Nome',
                        minWidth: 120
                    },
                    {
                        dataField: 'mobileNumber',
                        caption: 'Fone',
                        minWidth: 90,
                        cellTemplate: (element, info) => {
                            let p = String(info.data.mobileNumber || '').replace('+55', '');
                            let f = this.$util.applyMask(p, (p.length > 10) ? '(99) 9 9999-9999' : '(##) ####-####');
                            $(`<span>${f}</span>`).appendTo(element);
                        }
                    },
                    {
                        dataField: 'birth',
                        caption: 'Nascimento',
                        dataType: 'date',
                        format: 'dd/MM/yyyy',
                        width: 110
                    },
                    {
                        dataField: 'city',
                        caption: 'Cidade'
                    },
                    {
                        dataField: 'state',
                        caption: 'Estado',
                        width: 90
                    },
                    {
                        dataField: 'createdAt',
                        caption: 'Data de Cadastro',
                        dataType:"date",
                        format: 'dd/MM/yyyy hh:mm',
                    },
                    {
                        dataField: 'leads',
                        caption: 'Leads'
                    },
                    {
                        dataField: 'amountSum',
                        caption: 'Produção',
                        dataType: 'number',
                        format: function (value) {
                            return numeral(value).format('0,0.' + '0'.repeat(2));
                        }
                    },
                    {
                        dataField: 'affiliateCommissionSum',
                        caption: 'Comissão Afiliado',
                        dataType: 'number',
                        format: function (value) {
                            return numeral(value).format('0,0.' + '0'.repeat(2));
                        }
                    }
                ]
            };
        },

        created () {
        }
    });

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Affiliates.vue